/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { Box, Tooltip } from "@mantine/core";
import { ITableProps, kaReducer, Table } from "ka-table";
import {
  updatePageIndex,
} from "ka-table/actionCreators";
import DataRowContent from "ka-table/Components/DataRowContent/DataRowContent";
import {
  ActionType, DataType,
  SortDirection, SortingMode,
} from "ka-table/enums";
import { Column } from "ka-table/models";
import { IDataRowProps, IPagingProps } from "ka-table/props";
import "ka-table/style.css";
import { DispatchFunc } from "ka-table/types";
import React, {
  forwardRef,
  useMemo,
} from "react";
import isEqual from "react-fast-compare";
import ReactPaginate from "react-paginate";
import { ReactComponent as Sort } from "../../assets/images/sort.svg";
import AutomationTimestampCell from "./AutomationTimestampCell";
import AvatarCell from "./AvatarCell";
import DataCell from "./DataCell";
import DateCell from "./DateCell";
import DeleteSignalCell from "./DeleteSignalCell";
import DropdownCell from "./DropdownCell";
import EmptyTablePlaceholder from "./EmptyTablePlaceHolder";
import HeadCell from "./HeadCell";
import IconsGroupCell from "./IconsGroupCell";
import LocationCell from "./LocationCell";
import MemberCell from "./MemberCell";
import MetricCell from "./MetricCell";
import PercentCell from "./PercentCell";
import PlaybookActionsCell from "./PlaybookActionsCell";
import RelatedAccountsCell from "./RelatedAccountsCell";
import SignalActivityCell from "./SignalActivityCell";
import SignalNameCell from "./SignalNameCell";
import SourceCell from "./SourceCell";
import StatusCell from "./StatusCell";
import LastTimeEntry from "./LastTimeEntry";
import TopFeatureCell from "./TopFeatureCell";
import SignalStatusCell from "./SignalStatusCell";
import SignalOwnerCell from "./SignalOwnerCell";

export interface DataTable {

  totalData?: number,

  relation?: string,

  /**
   * Specifies the key of the column that should be used as the row key.
   */
  rowKeyField: string

  /**
   * Specifies if the column resizing should be enabled.
   */
  columnResizing?: boolean

  pageRange?: number

  /**
   * Height of the table.
   */
  height?: number

  /**
   * Specifies the initial sort direction.
   */

  /**
   * Specifies the callback to be called when the table is scrolled to the bottom
   *  for loading more data.
   * @param pageIndex - The current page index
   */
  serverCallback?: (
    pageIndex: number,
    sortBy: {
      key: string
      direction: SortDirection
    }
  ) => Promise<any>

  /**
   * Specifies the callback to be called when a row is clicked.
   */
  onRowClick?: (row: any) => void

  itemType?: string

  /**
   * Optional setter for the table data.
   */
  setData?: (data: any[]) => void

  /**
   * Callback to be called when no data is available.
   */
  noDataAvailable?: () => void

  /**
   * Callback to be called when column resize or reordered
   */
  onColumnChange?: (payload: IActionPayload) => void

  /**
   * Callback to be called when column resize or reordered
   */
  onSortChange?: (payload: { field: string, order: string, type?: string }) => void

  onPageChange?: (payload: number) => void

  tableProps: ITableProps,

  changeTableProps: any,

  kaDispatch: any,

  noDataMessage?: string,

  noDataTitle?: string
}

export interface IActionPayload {
  type: ActionType.ResizeColumn | ActionType.ReorderColumns
  columnKey: string
  targetColumnKey?: string
  width?: number
}

export interface ISortBy {
  key: string
  direction: SortDirection
  type?: string
}

export interface IColumn extends Column {
  key: string
  children?: IColumn[]
  displayName?: string
  parentKey?: string
  sortType?: string
  attributeType?: string
}

const KaTable = forwardRef(
  (
    {
      tableProps,
      changeTableProps,
      kaDispatch,
      itemType = "Items",
      totalData = 0,
      onColumnChange = () => {},
      onPageChange = () => {},
      onSortChange = () => {},
      onRowClick = () => {},
      pageRange = 5,
      noDataMessage,
      noDataTitle,
    }: DataTable,
    ref,
  ) => {
    const dispatch: DispatchFunc = (action) => {
      changeTableProps((prevState: ITableProps) => kaReducer(prevState, action));
      const sortColumn: any = tableProps.columns.find((c: any) => c.sortDirection);
      if (action.type === ActionType.ResizeColumn || action.type === ActionType.ReorderColumns) {
        if (action.type === ActionType.ResizeColumn) {
          onColumnChange({
            type: action.type,
            columnKey: action.columnKey,
            width: action.width,
          });
        } else {
          onColumnChange({
            type: action.type,
            columnKey: action.columnKey,
            targetColumnKey: action.targetColumnKey,
          });
        }
      }

      if (action.type === ActionType.UpdatePageIndex) {
        // change the page index
        onPageChange(action.pageIndex);
      }

      if (action.type === ActionType.UpdateSortDirection) {
        // change sort direction
        const newSortDirection = sortColumn?.sortDirection === SortDirection.Ascend
          ? SortDirection.Descend : SortDirection.Ascend;

        if (action.sortingMode === SortingMode.SingleRemote) {
          onSortChange({
            field: action.columnKey,
            order: newSortDirection === SortDirection.Ascend ? "asc" : "desc",
            type: sortColumn?.type || undefined,
          });
        }
      }
    };

    const ofs = useMemo(() => (
      (
        (((tableProps?.paging?.pageIndex ?? 0) * (tableProps?.paging?.pageSize ?? 1))
      % (totalData ?? 1))) + 1
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [tableProps?.paging?.pageIndex, tableProps?.paging?.pageSize, totalData]);

    return (
      <Box
        sx={(theme: any) => ({
          ".ka": {
            background: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
          },
          ".ka-dragged-row": {
            opacity: "0.5",
          },
          ".ka-drag-over-row": {
            boxShadow: "inset 0 7px 0px -4px red",
          },
          ".ka-dragged-row ~ .ka-drag-over-row": {
            boxShadow: "inset 0 -7px 0px -4px red",
          },
          ".ka-drag-over-column": {
            boxShadow: "inset 7px 0 0px -4px red",
          },
          ".ka-dragged-column ~ .ka-drag-over-column": {
            boxShadow: "inset -7px 0 0px -4px red",
          },
        })}
      >
        <Table
          {...tableProps}
          oddEvenRows
          dispatch={kaDispatch || dispatch}
          childComponents={{
            sortIcon: {
              content: ({ column }: any) => (
                <Tooltip withinPortal classNames={{ tooltip: "transform-none text-xs" }} label={`Sort ${column?.sortDirection === SortDirection.Ascend ? "Desc" : "Asc"}`}>
                  <Sort
                    className={`${column.sortDirection === SortDirection.Ascend ? "scale-y-[1]" : "scale-y-[-1]"} active:text-gray-900 shrink-0 cursor-pointer hover:text-gray-900`}
                  />
                </Tooltip>
              ),
            },
            headRow: {
              elementAttributes: () => ({
                style: {
                  width: "100%",
                },
                className: "!bg-gray-50 !border-gray-200",
              }),
            },
            headCell: {
              content: (props) => <HeadCell {...props} />,
              elementAttributes: () => ({
                style: {
                  height: "40px",
                  zIndex: 1,
                  width: "100%",
                },
                className: "!bg-gray-50 !z-[3] min-w-[100px] group hover:!bg-gray-100 !ease-linear !duration-200 !py-0 !pl-6 first:sticky left-0 first:!z-[4]",
              }),
            },
            noDataCell: {
              content: () => <EmptyTablePlaceholder title={noDataTitle} message={noDataMessage} />,
            },
            headCellResize: {
              elementAttributes: () => ({
                style: {
                  zIndex: 5,
                },
                className: "!bg-gray-200 !w-[3px] cursor-col-resize group-hover:!bg-gray-300 self-center hover:bg-gray-500",
              }),
            },
            dataRow: {
              content: (props: IDataRowProps) => <DataRowContentMemo {...props} />,
              elementAttributes: () => ({
                onClick: (_event: any, extendedEvent: { childProps: { rowData: any; }; }) => {
                  onRowClick(extendedEvent.childProps.rowData);
                },
                className: "[&:hover>*]:bg-gray-100 !ease-linear !duration-300 -z-[1]",
              }),
            },
            paging: {
              content: (props: IPagingProps) => (
                <div className="flex w-full border-t border-gray-200 z-[10] justify-between bg-white items-center px-6 py-4">
                  <div className="flex items-center space-x-2">
                    {(props?.pagesCount ?? 0) > 0 && (
                      <span className="text-sm font-medium text-gray-700">
                        <span className="font-semibold text-purple-700">{ofs || 0}</span>-<span className="font-semibold text-purple-700">
                          {ofs + ((props?.pageSize || 1) - 1) < totalData
                            ? ofs + ((props?.pageSize || 1) - 1)
                            : totalData}
                        </span> of <span className="font-semibold text-purple-700">{totalData}</span> {totalData === 1 ? itemType?.replace(/s$/, '') : itemType}
                      </span>
                    )}
                  </div>
                  
                  <ReactPaginate
                    previousLabel={(
                      <div className="flex items-center">
                        <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                        <span>Previous</span>
                      </div>
                    )}
                    nextLabel={(
                      <div className="flex items-center">
                        <span>Next</span>
                        <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    )}
                    breakLabel={<span className="px-2">...</span>}
                    marginPagesDisplayed={1}
                    forcePage={props?.pageIndex ?? 0}
                    pageCount={props?.pagesCount ?? 1}
                    onPageChange={async (selected: any) => {
                      await props.dispatch(
                        updatePageIndex(selected.selected),
                      );
                    }}
                    pageRangeDisplayed={pageRange}
                    containerClassName="flex items-center space-x-1"
                    pageLinkClassName="flex items-center justify-center w-8 h-8 rounded-md text-sm font-medium text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors"
                    previousLinkClassName="flex items-center px-3 py-1.5 rounded-md text-sm font-medium text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors"
                    nextLinkClassName="flex items-center px-3 py-1.5 rounded-md text-sm font-medium text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors"
                    disabledLinkClassName="opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-700"
                    activeLinkClassName="!bg-purple-600 !text-white hover:!bg-purple-700"
                    renderOnZeroPageCount={null}
                  />
                </div>
              ),
            },
            cell: {
              elementAttributes: () => ({
                style: {
                  overflow: "hidden",
                  verticalAlign: "middle",
                  padding: "0px 1.25rem",
                },
                className: "bg-white z-[0] relative text-sm text-gray-900 before:content-[''] before:inset-0 before:absolute before:border before:border-gray-100 ease-linear duration-200 first:sticky left-0 first:z-[2]",
              }),
              // eslint-disable-next-line consistent-return
              content: (props: any) => {
                const value = props.rowData[`${props?.column?.key}`];
                if (props.column.dataType === "delete_signal") {
                  return <DeleteSignalCell {...props} />;
                }
                if (props.column.dataType === "playbook_actions") {
                  return <PlaybookActionsCell {...props} />;
                }
                if (value === "null" || value === null || value === undefined) {
                  return <span className="block h-[5px] bg-gray-200 w-[40px] rounded-lg" />;
                }
                if (props.column.key === "related_accounts") {
                  return <RelatedAccountsCell {...props} />;
                }
                if (props.column.dataType === "signal_name") {
                  return <SignalNameCell {...props} />;
                }
                if (props.column.dataType === "signal_status") {
                  return <SignalActivityCell {...props} />;
                }
                if (props.column.dataType === "last_activity") {
                  return <LastTimeEntry {...props} />;
                } if (props.column.dataType === "top_feature") {
                  return <TopFeatureCell {...props} />;
                }
                if (props.column.key === "send_via") {
                  return <IconsGroupCell {...props} />;
                }
                if (props.column.dataType === "automation_timestamp") {
                  return <AutomationTimestampCell {...props} />;
                }
                if (props.column.key === "status") {
                  return <StatusCell {...props} />;
                }
                if (props.column.key === "sr.status") {
                  return <SignalStatusCell {...props} />;
                }
                if (props.column.key === "sr.owner_id") {
                  return <SignalOwnerCell {...props} />;
                }
                if (props.column.key.includes("retention") || props.column.key.includes("adoption")) {
                  return <PercentCell {...props} />;
                }
                if (props.column?.attributeType) {
                  if (props.column?.attributeType === "metric_traits") {
                    return <MetricCell {...props} />;
                  }
                }
                if (props.column.key === "accounts.csm_id" || props.column.key === "accounts.ae_id"
                || props.column.key === "accounts.ae_updated_by_user_id" || props.column.key === "accounts.csm_updated_by_user_id") {
                  return <MemberCell {...props} />;
                }
                if (props.column.key === "users.name" || props.column.key === "accounts.name" || props.column.key === "users.external_id" || props.column.key === "accounts.external_id") {
                  return <AvatarCell {...props} />;
                }
                if (props.column.key === "location") {
                  return <LocationCell {...props} />;
                }
                if (props.column.key.includes("source") || props.column.key === "src") {
                  return <SourceCell {...props} />;
                }
                if (props.column?.dataType === DataType.Object) {
                  return <DropdownCell {...props} />;
                }
                if (typeof value === "string" && value?.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}$/)) {
                  return <DateCell {...props} />;
                }
                return <DataCell {...props} />;
              },
            },
          }}
        />
      </Box>
    );
  },
);

const DataRowContentMemo = React.memo(
  (props: IDataRowProps) => <DataRowContent {...props} />,
  (prevProps, nextProps) => isEqual(prevProps.columns, nextProps.columns),
);

export default KaTable;
